import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Axios, { AxiosResponse, AxiosError } from 'axios'
import { AccessibleHelper } from '../utils/Accessible.util'
import { Uris } from '../common/constants'

const bootstrapAsync = async (store) => {
  Axios.defaults.baseURL = process.env.BASE_URL
  Axios.defaults.headers.common['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone
  // Axios.defaults.headers.common['X-App-Version'] = process.env.APP_VERSION || 'default' --Task 1181: Remove x-app-version from request header

  const token: string = localStorage.getItem('token')
  if (token) {
    Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }

  await Axios.get(Uris.AgencyInfo)
    .then(res => {
      document.title = 'Carnet d\'information du logement CIL'
      var link: any = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = 'https://res.cloudinary.com/driveim/image/upload/v1685530762/cil_transparent_j2lrkg.png'
      document.getElementsByTagName('head')[0].appendChild(link)
      store.commit('RECIEVE_CONFIGURATION', res.data)
    })
    .catch((err: AxiosError) => {
      console.log(err.response)
      store.commit('RECIEVE_CONFIGURATION_FAILED', err)
    })
}

Vue.use(VueRouter)

const createRoute = (path: string, componentUrl: string, name?: string, children?: RouteConfig[], views?: any, parent?:string) => {
  const route: any = {
    path: path,
    name: name,
    children: children,
    meta: {
      parent:parent
    }
  }

  if (views) {
    route.components = {
      default: async () => import('@/containers/' + componentUrl),
      ...views
    }
  } else {
    route.component = async () => import('@/containers/' + componentUrl)
  }
  return route
}

const blockApartmentChildren = [
  createRoute('', 'block/block-detail/BlockDetail.vue', 'block_detail',[],null,'block'),
  createRoute('apartment', 'block/block-apartments-grid/BlockApartmentsGrid.vue', 'block_apartments',[],null,'block_detail'),
  createRoute('apartment/:cid', 'block/block-child-detail/BlockChildDetail.vue', 'block_apartment_details', [], {
    childHeader: async () => import('@/containers/block/block-apartments-detail/BlockApartmentsDetail.vue'),
    content: async () => import('@/containers/block/components/block-tickets/BlockTickets.vue')
      // footerLeft: async () => import('@/containers/block/components/block-apartment-documents/BlockApartmentDocuments.vue')
  },'block_apartments'),
  createRoute('apartment/:cid/zones', 'block/block-zones/BlockZones.vue', 'block_zone',[],null,'block_apartment_details'),
  createRoute('ticket', 'block/block-tickets/BlockTickets.vue', 'ticket_list',[],null,'block_detail'),
  createRoute('equipment', 'block/block-equipments/BlockEquipments.vue', 'block_equipment',[],null,'block_detail'),
  createRoute('equipment/:cid', 'block/block-child-detail/BlockChildDetail.vue', 'block_equipment_details', [
  ], {
    childHeader: async () => import('@/containers/block/block-equipment-detail/BlockEquipmentDetail.vue')
  },'block_equipment'),
  createRoute('vehicleFleet', 'block/block-vehicle-fleet/BlockVehicleFleet.vue', 'block_vehicle_fleet',[],null,'block_detail'),
  createRoute('vehicle/:cid', 'block/block-child-detail/BlockChildDetail.vue', 'block_vehicle_details', [
  ], {
    childHeader: async () => import('@/containers/block/block-vehicle-detail/BlockVehicleDetail.vue')
  },'block_vehicle_fleet'),
  createRoute('maintenance', 'block/block-maintenances/BlockMaintenances.vue', 'block_maintenance',[],null,'block_detail'),
  createRoute('maintenance/:cid', 'block/block-maintenance-detail/BlockMaintenanceDetail.vue', 'block_maintenance_details',[],null,'block_maintenance'),
  createRoute('contact', 'block/block-tenants/BlockTenants.vue', 'block_tenants',[],null,'block_detail'),
  createRoute('tenant/:cid', 'block/block-child-detail/BlockChildDetail.vue', 'block_tenant_details', [], {
    childHeader: async () => import('@/containers/block/block-tenants-detail/BlockTenantsDetail.vue'),
    content: async () => import('@/containers/block/components/block-tickets/BlockTickets.vue')
    // footerLeft: async () => import('@/containers/block/components/block-tenant-activities/BlockTenantActivities.vue')
  },'block_tenants'),
  createRoute('owner', 'block/block-tenants/BlockTenants.vue', 'block_owners',[],null,'block_detail'),
  createRoute('owner/:cid', 'block/block-child-detail/BlockChildDetail.vue', 'block_owner_details', [], {
    childHeader: async () => import('@/containers/block/block-tenants-detail/BlockTenantsDetail.vue'),
    content: async () => import('@/containers/block/components/block-tickets/BlockTickets.vue')
  },'block_owners'),
  createRoute('document', 'block/block-documents/BlockDocuments.vue', 'block_documents',[],null,'block_detail'),
  createRoute('document/:cid', 'block/block-documents-detail/BlockDocumentsDetail.vue', 'block_document_details',[],null,'block_documents')
]

const router: VueRouter = new VueRouter({
  mode: 'history',
  routes: [
    createRoute('/agenda', 'agenda/Agenda.vue', 'agenda'),
    createRoute('/home', 'home/Home.vue', 'home'),
    createRoute('/ticket', 'ticket/Ticket.vue', 'ticket', [
      createRoute('', 'ticket/ticket-child-list/TicketChildList.vue', 'ticket_list'),
      createRoute(':id', 'ticket/ticket-child-list/TicketChildList.vue', 'ticket_list'),
      createRoute(':id/channel/:cid', 'ticket/ticket-child-chat/TicketChildChat.vue', 'ticket_chat',[],null,'ticket_list')
    ]),
    createRoute('/contact', 'contact/Contact.vue', 'contact'),
    createRoute('/block', 'block/Block.vue', 'block', [
      createRoute('', 'block/block-grid/BlockGrid.vue', 'block', [], {
        subnav: async () => import('@/containers/block/components/block-sidebar/BlockSidebar.vue')
      }),
      createRoute(':id', 'block/block-apartments/BlockApartments.vue', 'block_apartment_list', blockApartmentChildren, {
        subnav: async () => import('@/containers/block/components/block-apartment-sidebar/BlockApartmentSidebar.vue')
      },'block')
    ]),

    createRoute('/service-book', 'service-book/ServiceBook.vue', 'service_book', [
      createRoute('', 'service-book/home/ServiceBookHome.vue', 'service_book', [], {
        subnav: async () => import('@/containers/service-book/components/sidebar/BookServiceSidebar.vue')
      }),
      createRoute(':id', 'block/block-apartments/BlockApartments.vue', 'service_book_details', [
        createRoute('','service-book/details/ServiceBookDetails.vue','service_book_details',[],null,'service_book'),
        createRoute('tickets','ticket/ticket-child-list/TicketChildList.vue','service_book_details',[],null,'service_book_details'),
        createRoute('documents','block/block-documents/BlockDocuments.vue','service_book_details',[],null,'service_book_details'),
        createRoute('equipments','block/block-equipments/BlockEquipments.vue','service_book_details',[],null,'service_book_details'),
        createRoute('equipments/:cid', 'block/block-child-detail/BlockChildDetail.vue', 'service_book_details', [
        ], {
          childHeader: async () => import('@/containers/block/block-equipment-detail/BlockEquipmentDetail.vue')
        },'service_book_details'),
        createRoute('maintenances','block/block-maintenances/BlockMaintenances.vue','service_book_details',[],null,'service_book_details'),
        createRoute('maintenances/:cid', 'block/block-maintenance-detail/BlockMaintenanceDetail.vue', 'service_book_details',[],null,'service_book_details'),
      ], {
        subnav: async () => import('@/containers/service-book/components/sidebarDetails/BookServiceSidebarDetails.vue')
      })
    ]),


    createRoute('/profile', 'profile/Profile.vue', 'profile', [
      createRoute('', 'profile/profile-child/ProfileChild.vue', 'profile-child'),
      createRoute('team-management', 'profile/team-management/TeamManagement.vue', 'team-management',[],null,'profile-child'),
      createRoute('other-users', 'profile/team-management/TeamManagement.vue', 'other-users',[],null,'profile-child'),
      createRoute('char-problem', 'profile/char-problem/CharProblem.vue', 'agency_management_char_problems',[],null,'profile-child'),
      createRoute('char-problem/:id', 'profile/char-problem-detail/CharProblemDetail.vue', 'agency_management_char_problem_details',[],null,'agency_management_char_problems'),
      createRoute('attachment-type', 'profile/attachment-type/AttachmentType.vue', 'agency_management_attachment_types',[],null,'profile-child'),
      createRoute('attachment-type/:id', 'profile/attachment-type-detail/AttachmentTypeDetail.vue', 'agency_management_attachment_type_details',[],null,'agency_management_attachment_types'),
      createRoute('maintenance-template', 'profile/maintenance-template/MaintenanceTemplate.vue', 'agency_management_maintenance_template',[],null,'profile-child'),
      createRoute('ticket-closing-reasons', 'profile/ticket-closing-reasons/TicketClosingReasons.vue', 'ticket_closing_reason',[],null,'profile-child'),
      createRoute('ticket-substatus', 'profile/ticket-substatus/TicketSubstatus.vue', 'ticket_substatus',[],null,'profile-child'),
      createRoute('ticket-reasons', 'profile/ticket-reasons/TicketReasons.vue', 'ticket_reasons',[],null,'profile-child'),
    ]),
    createRoute('/document', 'documents/Document.vue', 'document', [
      createRoute('', 'documents/document-categories-list/DocumentCategories.vue', 'document_categories'),
      createRoute(':id', 'documents/document-attachment-list/DocumentAttachments.vue', 'document_attachment',[],null,'document_categories'),
      createRoute(':id/detail/:cid', 'documents/document-detail/DocumentDetail.vue', 'document_detail')
    ]),
    createRoute('/settings', 'settings/Settings.vue', 'settings_admin'),
    createRoute('/reception', 'mh-reception/MHReception.vue', 'reception', [
      createRoute('', 'mh-reception/mh-reception-child-list/MHReceptionChildList.vue', 'reception_report_list'),
      createRoute(':id', 'mh-reception/mh-reception-child-detail/MHReceptionChildDetail.vue', 'reception_report_details',[],null,'reception_report_list')
    ]),
    createRoute('/vehicle-check', 'mh-reception/MHReception.vue', 'reception', [
      createRoute('', 'mh-reception/mh-reception-child-list/MHReceptionChildList.vue', 'reception_report_list'),
      createRoute(':id', 'mh-reception/mh-reception-child-detail/MHReceptionChildDetail.vue', 'reception_report_details',[],null,'reception_report_list')
    ]),
    createRoute('/bm', 'building-monitor/BuildingMonitor.vue', 'building_monitor', [
      createRoute('', 'building-monitor/building-monitor-child-list/BuildingMonitorChildList.vue', 'building_monitor_list'),
      createRoute(':id', 'building-monitor/bm-meeting-child-list/BMMeetingChildList.vue', 'bm_meeting_list',[],null,'building_monitor_list'),
      createRoute(':id/meeting/:idm', 'building-monitor/bm-meeting-detail/BMMeetingDetail.vue', 'bm_meeting_detail',[],null,'bm_meeting_list')
    ]),
    createRoute('/', 'authorization/Authorization.vue', 'authorization', [
      createRoute('', 'login/Login.vue', 'login'),
      createRoute('/auth', 'login/Login.vue', 'login'),
      createRoute('/sign-up', 'signup/Signup.vue', 'signUp'),
      createRoute('/forgot-password', 'forgot-password/ForgotPassword.vue', 'forgot'),
      createRoute('/verify', 'signup-verification/SignupVerification.vue', 'signUpConfirmation'),
      createRoute('/reset', 'forgot-password-renew/ForgotPasswordRenew.vue', 'reset'),
      createRoute('/verifyChanges', 'change-email-verification/ChangeEmailVerification.vue', 'verifyChanges')
    ])
  ]
})

router.beforeEach(async (to, from, next) => {
  const canActive = AccessibleHelper.canActive(to.name)

  if (!canActive) {
    let defaultPath: string
    if (to.name === 'reset') {
      defaultPath = '/reset'
    } else {
      defaultPath = '/' + AccessibleHelper.getDetautPath()
    }
    next()
  } else {
    const activitiesOnSession = localStorage.getItem(to.name)
    if (activitiesOnSession !== null) {
      const funcs = JSON.parse(activitiesOnSession)
      Object.keys(funcs).forEach(key => to.meta[key] = true)
      next()
    } else {
      if (to.name !== 'home') {
        await Axios.get('/functionality', { params: { module: to.name } })
        .then((response: AxiosResponse) => {
          if (Array.isArray(response.data.data)) { return response.data || { data: [] } }
          return response.data.data || { data: [] }
        })
        .then(results => {
          const funcs = { [to.name]: {} }
          results.data.forEach(key => {
            funcs[to.name][key] = true
            to.meta[key] = true
          })
          return funcs
        })
        .then(funcs => {
          localStorage.setItem(to.name, JSON.stringify(funcs[to.name]))
          return funcs
        })
        .catch(error => {
          localStorage.removeItem(to.name)
          return error
        })
      }

      next(canActive)
    }
  }
})
export default router
export { bootstrapAsync }



// WEBPACK FOOTER //
// ./src/router/index.ts